import React from 'react';
import { Box, Chip } from '@mui/material';
import BuySellRowActions from './BuySellRowActions.jsx';

const stageColor = (stage) => {
  if (stage === 'Complete') return 'success';
  if (stage === 'D2C2') return 'info';
  return 'warning';
};

const formatTimestamp = (value) => {
  if (!value) return 'Not sent';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Not sent';
  return date.toLocaleString('en-US', { timeZone: 'America/Chicago' });
};

export const getBuySellColumns = ({ onDelete, onEdit, onPromote, onDemote, onForceSendEmail }) => [
  {
    field: '__actions',
    headerName: '',
    width: 64,
    sortable: false,
    filterable: false,
    renderCell: (params) => (
      <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
        <BuySellRowActions
          row={params.row}
          onDelete={onDelete}
          onEdit={onEdit}
          onPromote={onPromote}
          onDemote={onDemote}
          onForceSendEmail={onForceSendEmail}
        />
      </Box>
    ),
  },
  {
    field: 'accountName',
    headerName: 'Account name',
    flex: 1.4,
    minWidth: 200,
  },
  {
    field: 'accountId',
    headerName: 'Selling Salesforce Account ID',
    flex: 1,
    minWidth: 200,
  },
  {
    field: 'buySellAccountId',
    headerName: 'Purchasing Salesforce Account ID',
    flex: 1.1,
    minWidth: 230,
  },
  {
    field: 'buySellStage',
    headerName: 'Buy/Sell stage',
    flex: 0.9,
    minWidth: 150,
    renderCell: (params) => (
      <Chip size="small" label={params.value} color={stageColor(params.value)} variant="outlined" />
    ),
  },
  {
    field: 'stageDate',
    headerName: 'Stage date',
    flex: 0.8,
    minWidth: 130,
  },
  {
    field: 'bac',
    headerName: 'Selling BAC',
    flex: 0.7,
    minWidth: 110,
  },
  {
    field: 'purchasingBAC',
    headerName: 'Purchasing BAC',
    flex: 0.8,
    minWidth: 130,
  },
  {
    field: 'lastEmailSentAt',
    headerName: 'Last alert sent',
    flex: 0.9,
    minWidth: 160,
    valueFormatter: (params) => formatTimestamp(params?.value),
  },
  {
    field: 'hasDafAttachment',
    headerName: 'DAF',
    flex: 0.6,
    minWidth: 100,
    renderCell: (params) => (
      <Chip
        size="small"
        label={params.value ? 'Uploaded' : 'Missing'}
        color={params.value ? 'success' : 'default'}
        variant={params.value ? 'filled' : 'outlined'}
      />
    ),
    sortable: false,
    filterable: false,
  },
];
